import React, { useEffect , useRef , useContext } from 'react';
import RequestFaq from './RequestFaq';
import RequestFaqdoc from './RequestFaqdoc';
import RequestSupport from './RequestSupport';
import RequestSendbak from './RequestSendbak';
import RequestChatgpt from './RequestChatgpt';
import RequestManual from './RequestManual';
import RequestCsiaction from './RequestCsiaction';
import RequestCsiNote from './RequestCsiCsiNote';
import RequestFaqchat from './RequestFaqchat';


const ApiHandler = {
    search: async (input,filtermessages, userId,mode,loginInfo,setMessages) => {
        const apiUrl = '/api/search'; // API のエンドポイント

        switch (mode) {
        case 'faq':
            return await RequestFaq(input,filtermessages, userId,mode,loginInfo);
        case 'faqchat':
            return await RequestFaqchat(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'support':
            return await RequestSupport(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'sendbak':
            return await RequestSendbak(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'chatgpt':
            return await RequestChatgpt(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'faqdoc':
            return await RequestFaqdoc(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'manual':
            return await RequestManual(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'csiaction':
            return await RequestCsiaction(input,filtermessages, userId,mode,loginInfo,setMessages);
        case 'csinote':
            return await RequestCsiNote(input,filtermessages, userId,mode,loginInfo,setMessages);
    
        default:
            break;
        }
    },
};


export default ApiHandler;


